/**
 * 渲染期异常兜底。
 * 画布与 JSON 渲染都可能因为一份畸形数据整棵树崩掉，
 * 边界包住之后至少侧边导航还在，用户能走开而不是只剩白屏。
 */

import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button, Result, Typography } from 'antd';

interface Props {
  children: ReactNode;
  /** 用于区分不同区域的边界，展示在标题里 */
  scope?: string;
  fallback?: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[ErrorBoundary]', this.props.scope ?? '', error, info.componentStack);
  }

  private reset = () => this.setState({ error: null });

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    if (this.props.fallback) return this.props.fallback;

    return (
      <Result
        status="error"
        title={this.props.scope ? `${this.props.scope} 渲染出错` : '页面渲染出错'}
        subTitle={
          <Typography.Paragraph
            copyable
            style={{ maxWidth: 640, margin: '0 auto', textAlign: 'left' }}
          >
            {error.message}
          </Typography.Paragraph>
        }
        extra={[
          <Button key="retry" type="primary" onClick={this.reset}>
            重试
          </Button>,
          <Button key="reload" onClick={() => window.location.reload()}>
            刷新页面
          </Button>,
        ]}
      />
    );
  }
}
